.fd{width:1rem;}